"use client";

import { Ecommerce } from "@/lib/nexus-app";
import React, { createContext, useContext } from "react";

const EcommerceContext = createContext<Ecommerce | null>(null);

export function EcommerceProvider({
  ecommerce,
  children,
}: {
  ecommerce: Ecommerce;
  children: React.ReactNode;
}) {
  return (
    <EcommerceContext.Provider value={ecommerce}>
      {children}
    </EcommerceContext.Provider>
  );
}

export function useEcommerce() {
  const ctx = useContext(EcommerceContext);
  if (!ctx)
    throw new Error("useEcommerce musi być użyty wewnątrz EcommerceProvider");
  return ctx;
}
